module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Bold-612241e20224bc56c9364ffa29ad7e07accb8bbe19e01a00d9d108c509ef9b63.svg";